import React from 'react';

export default function (props) {
  const { show, children, className } = props;
  return <div className={show ? className : 'hidden'}>{children}</div>;
}
